import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { CHECK_EXERCISE_COMPLETED, CHECK_EXERCISE_REQUESTED, HIDE_COMPLETION_PANE, SHOW_EXERCISE, SHOW_HINT, TAKE_SOLUTION_COMPLETED, TAKE_SOLUTION_FAILED, TAKE_SOLUTION_REQUESTED } from '../actions/types';
const initialState = {};
const defaults = {
  checking: false,
  completionPaneVisible: false,
  feedbackMessages: [],
  settingSolution: false,
  solutionShown: false,
  successMessage: '',
  xpLost: 0
};
export default (function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case CHECK_EXERCISE_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        [action.id]: _objectSpread(_objectSpread({}, state[action.id]), {}, {
          checking: true
        })
      });
    case CHECK_EXERCISE_COMPLETED:
      {
        const lastSubmission = {
          message: action.message,
          success: action.success
        };
        if (action.success) {
          return _objectSpread(_objectSpread({}, state), {}, {
            [action.id]: _objectSpread(_objectSpread({}, state[action.id]), {}, {
              checking: false,
              completionPaneVisible: true,
              lastSubmission,
              successMessage: action.message
            })
          });
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          [action.id]: _objectSpread(_objectSpread({}, state[action.id]), {}, {
            checking: false,
            feedbackMessages: [...state[action.id].feedbackMessages, action.messageId],
            lastSubmission
          })
        });
      }
    case HIDE_COMPLETION_PANE:
      return _objectSpread(_objectSpread({}, state), {}, {
        [action.exerciseId]: _objectSpread(_objectSpread({}, state[action.exerciseId]), {}, {
          completionPaneVisible: false
        })
      });
    case SHOW_EXERCISE:
      return _objectSpread(_objectSpread({}, state), {}, {
        [action.id]: _objectSpread(_objectSpread(_objectSpread({}, defaults), state[action.id]), {
          completionPaneVisible: false
        })
      });
    case SHOW_HINT:
      return _objectSpread(_objectSpread({}, state), {}, {
        [action.exerciseId]: _objectSpread(_objectSpread({}, state[action.exerciseId]), {}, {
          feedbackMessages: [...state[action.exerciseId].feedbackMessages, action.messageId],
          xpLost: state[action.exerciseId].xpLost + action.xpCost
        })
      });
    case TAKE_SOLUTION_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        [action.exerciseId]: _objectSpread(_objectSpread({}, state[action.exerciseId]), {}, {
          settingSolution: true,
          solutionShown: true,
          xpLost: state[action.exerciseId].xpLost + action.xpCost
        })
      });
    case TAKE_SOLUTION_COMPLETED:
      return _objectSpread(_objectSpread({}, state), {}, {
        [action.exerciseId]: _objectSpread(_objectSpread({}, state[action.exerciseId]), {}, {
          settingSolution: false
        })
      });
    case TAKE_SOLUTION_FAILED:
      return _objectSpread(_objectSpread({}, state), {}, {
        [action.exerciseId]: _objectSpread(_objectSpread({}, state[action.exerciseId]), {}, {
          settingSolution: false,
          solutionShown: false,
          xpLost: state[action.exerciseId].xpLost - action.xpRefund
        })
      });
    default:
      return state;
  }
});